import React from 'react';
import { string } from 'prop-types';

const PageTitle = ({ title, className }) => <h1 className={`text-3xl lg:text-4xl ${className}`}>{title}</h1>;

PageTitle.propTypes = {
  title: string,
  className: string,
};

PageTitle.defaultProps = {
  title: null,
  className: null,
};

export default PageTitle;
